export const getElemDistance = function (elem) {
  var location = 0;
  if (elem?.offsetParent) {
    do {
      location += elem.offsetTop;
      elem = elem.offsetParent;
    } while (elem);
  }
  return location >= 0 ? location : 0;
};

export const getMaxZIndexInContainer = (container) => {
  const scope = container || document.body;
  const elements = scope.querySelectorAll("*");
  let max = 0;

  for (let el of elements) {
    const z = window.getComputedStyle(el).zIndex;
    const zIndex = parseInt(z, 10);
    if (!isNaN(zIndex)) {
      max = Math.max(max, zIndex);
    }
  }
  return max;
};
